
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GoldBoxEcuComparison"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"goldBoxEcuComparison"},"name":{"kind":"Name","value":"goldBoxEcuAttributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sequential"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupFireMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rotary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"injectorOutputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ignitionOutputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"auxiliaryOutputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"outputOptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"individualCylinderTables"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"triggerInputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avInputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"atInputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"digitalSpeedInputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"swLambdaInputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dwLambdaImputs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rs232"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"can"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataLogging"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxLoggingRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trackMapping"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"i2ProAnalysis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telemetry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remoteLogging"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"boostControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nitrousInjection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dualStageInjection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groundSpeedLimiting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tractionAndLaunchControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overrunBoostEnhancement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gearChangeIgnitionCut"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stepperMotorIdleControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cvCamshaftControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dbwThrottleControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"servoMotorControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"knockControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refSyncCapture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"multiConfig"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"passwordProtection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expanderCapability"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paddleShiftControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":906}};
    doc.loc.source = {"body":"query GoldBoxEcuComparison {\n  goldBoxEcuComparison: goldBoxEcuAttributes {\n    documentId\n    sequential\n    groupFireMode\n    rotary\n    injectorOutputs\n    ignitionOutputs\n    auxiliaryOutputs\n    outputOptions\n    individualCylinderTables\n    triggerInputs\n    avInputs\n    atInputs\n    digitalSpeedInputs\n    swLambdaInputs\n    dwLambdaImputs\n    rs232\n    can\n    dataLogging\n    maxLoggingRate\n    trackMapping\n    i2ProAnalysis\n    telemetry\n    remoteLogging\n    boostControl\n    nitrousInjection\n    dualStageInjection\n    groundSpeedLimiting\n    tractionAndLaunchControl\n    overrunBoostEnhancement\n    gearChangeIgnitionCut\n    stepperMotorIdleControl\n    cvCamshaftControl\n    dbwThrottleControl\n    servoMotorControl\n    knockControl\n    refSyncCapture\n    multiConfig\n    passwordProtection\n    expanderCapability\n    paddleShiftControl\n    product {\n      documentId\n      name\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GoldBoxEcuComparison"] = oneQuery(doc, "GoldBoxEcuComparison");
        
